import { render } from "./hitPoint.vue?vue&type=template&id=04f6496f&scoped=true"
import script from "./hitPoint.vue?vue&type=script&lang=js"
export * from "./hitPoint.vue?vue&type=script&lang=js"

import "./hitPoint.vue?vue&type=style&index=0&id=04f6496f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f6496f"]])

export default __exports__